import React from 'react'
import { Outlet } from 'react-router-dom'
import Navigation from './Navigation'
import { SkipLink, useAnnouncer } from './ui/accessibility'

export default function Layout() {
  const { AnnouncementRegion } = useAnnouncer()

  return (
    <div className="min-h-screen bg-neutral-50">
      <SkipLink href="#main-content">Skip to main content</SkipLink>
      <SkipLink href="#navigation">Skip to navigation</SkipLink>

      <header role="banner">
        <Navigation />
      </header>

      <main
        id="main-content"
        role="main"
        className="container mx-auto px-6 py-12 max-w-7xl"
        tabIndex={-1}
      >
        <Outlet />
      </main>

      <AnnouncementRegion />
    </div>
  )
}